import 'whatwg-fetch';
import config, {AUTH_INVALID_TOKEN} from '../../config/config';
import {dropToken, receiveUserData, requestUserData} from "../../components/UserLogin/actions";
import {toastr} from "react-redux-toastr";
import _ from "lodash";
import {receive1PageOrders} from "../Orders/actions";
import {receiveEvents, requestEvents} from "../Events/actions";
import {useNavigate} from "react-router";

export const REQUEST_COUNTERS = 'REQUEST_COUNTERS';
export const RECEIVE_COUNTERS = 'RECEIVE_COUNTERS';
export const RECEIVE_1PAGE_COUNTERS = 'RECEIVE_1PAGE_COUNTERS';
export const RECEIVE_SINGLE_COUNTER = 'RECEIVE_SINGLE_COUNTER';
export const CREATE_COUNTER = 'CREATE_COUNTER';
export const COUNTERS_PAGE_COUNT = 20;
export const FINISH_COUNTERS_FETCHING = 'FINISH_COUNTERS_FETCHING';

export const requestCounters = () => ({
    type: REQUEST_COUNTERS,
})

export const receiveCounters = (counters) => ({
    type: RECEIVE_COUNTERS,
    counters,
})

export const receiveSingleCounter = (counter) => ({
    type: RECEIVE_SINGLE_COUNTER,
    payload: counter,
})

export const receive1PageCounters = (counters) => ({
    type: RECEIVE_1PAGE_COUNTERS,
    counters,
})

export const finishCountersFetching = () => ({
    type: FINISH_COUNTERS_FETCHING
});



const process_api_error = (json, dispatch, t) => {
    if (json.code === AUTH_INVALID_TOKEN) {
        dispatch(dropToken())
    }
    toastr.error(t('serverError') + String(json.code) + '. ' + json.message)
    dispatch(finishCountersFetching())
}

export const fetchCounters = (token = null, params = {}, t) => (dispatch) => {
    dispatch(requestCounters());

    const headers = { Authorization: 'Bearer ' + token };
    let url;
    if (params && params.id) {
        url = config.API_COUNTER_URL + String(params.id);
    } else {
        url = config.API_COUNTERS_URL
            + '?'
            + Object.keys(params)
                .map((k) => k + '=' + encodeURIComponent(params[k]))
                .join('&');
    }

    return fetch(url, { headers, credentials: 'include' })
        .then(res => res.json())
        .then((json) => {
            if (json.code === 200) {
                if (params.id) {
                    dispatch(receiveSingleCounter(json.data));
                    return json.data;
                } else {
                    dispatch(params.page === 1 ? receive1PageCounters(json.data) : receiveCounters(json.data));
                    return json.data;
                }
            } else {
                process_api_error(json, dispatch, t);
               if (params.id) {
                   history.back()
               }
            }
        })
        .catch((err) => {
            toastr.error(t('requestError') + String(err));
        });
};

export const createCounter = (token = null, params = {}, t) => (dispatch) => {
    dispatch(requestCounters())
    const headers = token ? {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
    } : {};
    let url = config.API_CREATE_COUNTER_URL;
    const obj = JSON.stringify(params);
    return fetch(url, { method: 'post', headers, credentials: 'include', body: obj, })
        .then((response) => response.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveCounters(json.data));
                return json.data;
            } else {
                dispatch(receiveCounters([]));
                process_api_error(json, dispatch, t);
            }
        })
        .catch( (ex) => {
            dispatch(receiveCounters([]));
            toastr.error(t('requestError') + String(ex))
        });
}

export const changeCounter = (token = null, id, params = {}, t) => (dispatch) => {
    dispatch(requestCounters());
    const headers = token ?{
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
    } : {};
    let url;
    url = config.API_CHANGE_COUNTER_URL + String(id);
    const obj = JSON.stringify(params);

        return fetch(url, { method: 'post', headers, credentials: 'include', body: obj, })
        .then(res => res.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveSingleCounter(json.data));
            } else {
                process_api_error(json, dispatch, t);
            }
        })
        .catch((err) => {
            toastr.error(t('requestError') + String(err));
        });
};

